const breadcrumbs: Record<string, string | Record<string, string>> = {
    campaigns: 'Услуги',
    campaign: 'Услуга',
    requests: 'Заявки',
    campaignSettings: 'Настройки услуги',
    regFormSelect: 'Выбор формы подачи заявки',
};

export default breadcrumbs;
